import React from "react";
import { useTranslation } from "react-i18next";
import LightButton from "Shared/Buttons/LightButton";
import useSelector from "src/utils/useSelector";

interface Props {
    handleClick: () => void;
}

const DoneButton = ({ handleClick }: Props) => {
    const { t } = useTranslation();
    const label = useSelector((state) => state.account?.account_disclaimers?.upgrades_label);

    return (
        <div className={`accessories_done_button`}>
            <LightButton onClick={handleClick}>{t("Accessories.done", { label })}</LightButton>
        </div>
    );
};

export default DoneButton;
